import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { connect } from "react-redux";

import LayoutWrapper from "../../../../common/LayoutWrapper";
import DocSwiper from "../../../../common/Swipers/DocsSwiper";
import GetStarted from "../../../../components/cases/documents/organDonation/GetStarted";
import Declaration from "../../../../components/cases/documents/organDonation/Declaration";
import OrganDonationOverview from "../../../../components/cases/documents/organDonation/OrganDonationOverview";
import AdviserDocsWrapper from "../../../../common/AdviserDocsWrapper";

import { customTab, nextTab, preTab } from "../../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../../redux/slices/features/assetsOnBoardingSlice";
import { resetCard } from "../../../../redux/slices/CardSlices";
import { organDonation } from "../../../../constants/constants";
import { getOrganDonationData } from "../../../../services/documentServices";
import {
  getUserIdFromLocalStorage,
  overAllStatus,
} from "../../../../utils/Utilities";
import { useLocation, useParams } from "react-router-dom";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import { useTranslation } from "react-i18next";

const OrganDonationPage = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [steps, setSteps] = useState(organDonation);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };
  const tabMaping = {
    1: (
      <GetStarted
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <Declaration
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    3: (
      <OrganDonationOverview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const arr = [];
    const result = await getOrganDonationData(id);
    if (result?.success) {
      const {
        organDonationAuthorizePerson,
        organDonationPersonDetail,
        declarationType,
      } = result.payLoad;
      const array = [
        organDonationPersonDetail?.stepStatus,
        declarationType < 5 ? 2 : organDonationAuthorizePerson?.stepStatus,
        2,
      ];

      steps.forEach((elem, index) => {
        if (index !== steps.length - 1) {
          arr.push({ ...elem, stepStatus: array[index] });
        }
        if (index === steps.length - 1) {
          const res = overAllStatus(array);
          arr.push({ ...elem, stepStatus: res ? 2 : 1 });
        }
      });

      setSteps(arr);
    }
  }

  useEffect(() => {
    fetchData();
  }, [currentTab]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return tabMaping[currentTab];
  };
  return (
    <>
      <AdviserDocsWrapper>
        <LayoutWrapper
          minHeight="calc(100vh - 120px) !important"
          borderShadow={true}
        >
          <DocSwiper
            tab={currentTab}
            back={handleBack}
            custom={handleCustomTab}
            list={steps}
            showTooltip={false}
            maxWidthSwiper={true}
          />
          {renderTab()}
          {currentTab < 3 ? (
            <div
              style={{
                minWidth: "310px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <SecondaryButton
                title={t("save-and-continue")}
                bgColor="#E8D7E5"
                borderRadius="14px"
                width="180px"
                marginLeft="20px"
                border="none"
                hoverBgColor="color.magentaLight1"
                textTransform="initial"
                padding="0rem"
                height="2.7rem"
                form="form_submit"
                type="submit"
                disabled={buttonDisabled}
              />

              <LinkButton
                title={t("skip-for-now")}
                bgColor="color.transparent"
                borderRadius="14px"
                fontSize="0.8rem"
                width="110px"
                marginLeft="0px"
                border="none"
                click={handleNext}
                textTransform="initial"
              />
            </div>
          ) : (
            <div
              className="button-container-2"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <PrimaryButton
                title={t("save")}
                bgColor="#E8D7E5"
                color="#444561"
                padding="10px 60px"
                textTransform="initial"
                borderRadius={"18px"}
                boxShadow={0}
                form="form_submit"
                type="submit"
              />
            </div>
          )}
        </LayoutWrapper>
      </AdviserDocsWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganDonationPage);
